<template>
  <keep-alive include="dailyPushList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "DailyPush",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
